import React from 'react';
import Main from './Main';
import http from '../../common/api/http';

import {LoadFormState, SOCKET_STATUSES, StatesLoadForm, STATUS_LOAD} from '../../common/const/const';
import {connect} from 'react-redux';
import Socket from '../../common/api/socket';

class MainContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: LoadFormState.ru_load_site,
            activeStateForm: StatesLoadForm.chooseFile,
            formFile: null,
            statesLoadFile: null,
            isChangeTab: true,
            allowUpload: true,
        };

        this.handleChangeTab = this.handleChangeTab.bind(this);
        this.handleChangeFile = this.handleChangeFile.bind(this);
        this.handleLoadFile = this.handleLoadFile.bind(this);
        this.handleLoadNewFile = this.handleLoadNewFile.bind(this);
    }

    async handleChangeTab(tab) {
        if (Object.keys(LoadFormState).indexOf(tab) !== -1 && this.state.isChangeTab) {
            await this.setState({
                activeTab: tab,
                activeStateForm: StatesLoadForm.chooseFile,
                formFile: null,
            });
        }
    }

    async handleChangeFile(event) {
        await this.setState({
            formFile: event.currentTarget.files[0],
        });
    }

    async handleLoadNewFile() {
        await this.setState({
            activeStateForm: StatesLoadForm.chooseFile,
            formFile: null,
            statesLoadFile: null,
        })
    }

    async validateArchiveName(lang) {
        const formFile = this.state.formFile;

        if (formFile !== null) {
            let allowUpload = false;

            if (lang === 'ru' && formFile.name.startsWith(process.env.REACT_APP_MASK_ARCHIVE_RU)) {
                allowUpload = true;
            }

            if (lang === 'eng' && formFile.name.startsWith(process.env.REACT_APP_MASK_ARCHIVE_ENG)) {
                allowUpload = true;
            }

            if (lang === 'kz' && formFile.name.startsWith(process.env.REACT_APP_MASK_ARCHIVE_KZ)) {
                allowUpload = true;
            }

            if (lang === 'az' && formFile.name.startsWith(process.env.REACT_APP_MASK_ARCHIVE_AZ)) {
                allowUpload = true;
            }

            if (allowUpload === false) {
                alert('Не правильное название архива');
            }

            await this.setState({
                allowUpload: allowUpload
            })
        }
    }

    async handleLoadFile() {
        if (this.state.formFile) {
            const {
                authService,
            } = this.props;
            const splitedTab = this.state.activeTab.split('_');
            const lang = splitedTab[0] === 'com' ? 'eng' : splitedTab[0];
            const loadFileType = splitedTab[2] === 'site' ? 'archive' : 'review';

            const accessToken = authService.getAccessToken();
            const authHeader = `Bearer ${accessToken}`;
            const url = `/api/upload/${loadFileType}`;

            const formData = new FormData();
            formData.append(loadFileType, this.state.formFile);
            formData.append('lang', lang);

            if (loadFileType === 'archive') {
                await this.validateArchiveName(lang);
            }

            if (this.state.allowUpload === true) {
                http.loadFile('post', url, formData, authHeader).then((res) => {
                    if (res.error) {
                        alert("Возникла ошибка на сервере, попробуйте попозже");
                    }
                });
                // console.log(response);
                // if (response.error) { alert('Возникла ошибка на сервере'); return false; }
                this.setState({
                    activeStateForm: StatesLoadForm.loadFile,
                    isChangeTab: false,
                });
                const statesLoadFile = {};
                if (loadFileType === 'archive') {
                    statesLoadFile[SOCKET_STATUSES.archive_loaded] = STATUS_LOAD.load;
                    statesLoadFile[SOCKET_STATUSES.archive_unpacked] = STATUS_LOAD.promise;
                    statesLoadFile[SOCKET_STATUSES.done] = STATUS_LOAD.promise;
                }
                if (loadFileType === 'review') {
                    statesLoadFile[SOCKET_STATUSES.done] = STATUS_LOAD.load;
                }
                this.setState({statesLoadFile});
                Socket.getInstance().subscribeArchiveLoaded(() => {
                    this.setState((state) => {
                        state.statesLoadFile[SOCKET_STATUSES.archive_loaded] = STATUS_LOAD.success;
                        state.statesLoadFile[SOCKET_STATUSES.archive_unpacked] = STATUS_LOAD.load;
                        return {statesLoadFile: state.statesLoadFile};
                    })
                });
                Socket.getInstance().subscribeArchiveUnpacked(() => {
                    this.setState((state) => {
                        state.statesLoadFile[SOCKET_STATUSES.archive_unpacked] = STATUS_LOAD.success;
                        state.statesLoadFile[SOCKET_STATUSES.done] = STATUS_LOAD.load;
                        return {statesLoadFile: state.statesLoadFile};
                    })
                });
                Socket.getInstance().subscribeArchiveDone(() => {
                    this.setState((state) => {
                        state.statesLoadFile[SOCKET_STATUSES.done] = STATUS_LOAD.success;
                        return {statesLoadFile: state.statesLoadFile, isChangeTab: true};
                    })
                });
            }
        } else {
            alert('Выберите файл для загрузки');
        }
    }

    render() {
        return <Main
            statesLoadFile={this.state.statesLoadFile}
            formFile={this.state.formFile}
            handleChangeFile={this.handleChangeFile}
            handleLoadFile={this.handleLoadFile}
            handleLoadNewFile={this.handleLoadNewFile}
            onChangeTab={this.handleChangeTab}
            activeTab={this.state.activeTab}
            activeStateForm={this.state.activeStateForm}
            {...this.props}
        />;
    }
}

const mapStateToProps = (state) => ({domain: state.domain.domain});

export default connect(mapStateToProps)(MainContainer);
